// @flow

import type { SpecData } from './types';

const example: SpecData = {
  tonsPerHour: 600,
  conveyorLength: 80,
  conveyorSpeed: 150,
  conveyorRise: 30,
  headPulleyDiameter: 14,
  headPulleyShaftDiameter: '0: Gearbox Maximum',
  // headPulleyShaftDiameter: '1.3125: 1.3125" (1 5/16")',
  // headPulleyShaftDiameter: '3.4375: 3.4375" (3 7/16")',
  // headPulleyShaftDiameter: '1.9375: 1.9375" (1 15/16")',
  serviceFactor: '1.4: 3 - 10 hrs/day moderate shock',
  // serviceFactor: '2: > 10 hrs/day moderate shock',
  motorSpeed: 1750,
  ambientTemp: 105,
  dutyCycle: 100,
  altitude: 2600,
  spaceDescription: '1.5: Unsheltered outdoor space'
};

export default example;



// WEBPACK FOOTER //
// ./src/utils/vortex/example.js